export default __webpack_public_path__ + "static/media/img_step_appliance10.488afe3e.jpg";